import { Injectable } from '@angular/core';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class CarregamentoEntregaInativoService extends GenericServicesMotoristaService {

  constructor(private _mensagensService: MensagensService,
    private _httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/carregamentoEntregaInativo';
  }

  ativarCarregamento(idCarregamento, idUsuario) {
    return this.post('/ativarCarregamento', {
      dados: {
        carregamento: idCarregamento,
        usuario: idUsuario
      },
      enviarComoQueryString: true
    });
  }

  inativarCarregamento(idCarregamento, idUsuario) {
    return this.post('/inativarCarregamento', {
      dados: {
        carregamento: idCarregamento,
        usuario: idUsuario
      },
      enviarComoQueryString: true
    });
  }

}
